<template>
    <div class="textpicker">
        <div class="textpicker__wrap">
            <app-controlhead
                :title="$helpers.uiText('R069')"
                :help="$helpers.uiText('R070')"
                :show-close="true"
                :show-remove="false"
                :show-save="false"
                :show-global="false"
                @close="closeTextpicker"
            ></app-controlhead>

            <ul class="textpicker__list">
                <li
                    class="textpicker__list-item"
                    v-for="(texts__value, texts__key) in getRandomTextsInCurrentNamespace"
                    :key="texts__key"
                >
                    <div
                        :data-id="texts__value.id"
                        @mouseup="updateSelection()"
                        class="textpicker__text"
                    >
                        {{ texts__value.content }}
                    </div>
                    <a
                        v-if="isSelectionActive(texts__value.id)"
                        v-on:click.prevent="emitTextpicker(getCurrentSelection())"
                        href="#"
                        class="textpicker__button button-icon button-icon--use-selection"
                        >ausgewählten Text übernehmen</a
                    >
                    <a
                        v-else
                        v-on:click.prevent="emitTextpicker(texts__value.content)"
                        href="#"
                        class="textpicker__button button-icon button-icon--use-text"
                        >kompletten Text übernehmen</a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Controlhead from '@/components/assorted/Controlhead';

export default {
    data() {
        return {
            selectedParentEl: null
        };
    },
    components: {
        'app-controlhead': Controlhead
    },
    methods: {
        ...mapActions(['closeTextpicker', 'emitTextpicker']),
        updateSelection() {
            // short timeout to overcome delay issues
            setTimeout(() => {
                if (
                    window.getSelection().anchorNode === undefined ||
                    window.getSelection().anchorNode === null ||
                    window.getSelection().anchorNode === '' ||
                    window.getSelection().type !== 'Range'
                ) {
                    this.selectedParentEl = null;
                } else {
                    this.selectedParentEl = window
                        .getSelection()
                        .anchorNode.parentElement.getAttribute('data-id');
                }
            }, 100);
        },
        isSelectionActive(id) {
            return this.selectedParentEl == id;
        },
        getCurrentSelection() {
            if (
                window.getSelection().anchorNode === undefined ||
                window.getSelection().anchorNode === null ||
                window.getSelection().anchorNode === '' ||
                window.getSelection().type !== 'Range'
            ) {
                return '';
            }
            return window.getSelection().toString();
        }
    },
    computed: {
        ...mapGetters(['getRandomTextsInCurrentNamespace', 'isActiveText'])
    },
    created() {},
    props: {}
};
</script>
